import { React } from 'react';
import styled from 'styled-components';

export default function NewGuestPhoneInput(props) {
  const { value, setValue, placeholder, disabled } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    let phone = e.target.value;

    const regex = /^[0-9\b -]*$/;

    if (regex.test(phone)) {
      setValue(phone);
      // if (phone.length === 10) setValue(phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
      // else if (phone.length === 13) setValue(phone.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
      // else setValue(phone);
    }
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <InputWrapper $disabled={disabled}>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputWrapper>
  )
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 7px 12px 7px 12px;

  width: calc(100% - 26px);
  
  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
  opacity: ${props => props.$disabled ? 0.4 : 1};
  transition: opacity 0.3s ease-in-out;
`;

const Input = styled.input`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  width: 100%;
  height: 100%;

	outline: none;
  border: 0px;
  
	color: ${props => props.theme.text};
  background-color: transparent;

	&::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

    color: ${props => props.theme.line};
	}
	
  transition: all 0.3s ease-in-out;
`;